export const handleDownload = async (url, fileNameOverride) => {
    const deriveFileName = (inputUrl) => {
        try {
            const parsed = new URL(inputUrl, window.location.href);
            const lastSegment = decodeURIComponent(parsed.pathname.split('/').pop() || 'download');
            if (lastSegment.toLowerCase().endsWith('.pdf')) return lastSegment;
            return `${lastSegment || 'download'}.pdf`;
        } catch (_) {
            return 'download.pdf';
        }
    };

    const triggerBrowserDownload = (href, suggestedName) => {
        const anchorElement = document.createElement('a');
        anchorElement.href = href;
        if (suggestedName) anchorElement.download = suggestedName;
        anchorElement.style.display = 'none';
        document.body.appendChild(anchorElement);
        anchorElement.click();
        document.body.removeChild(anchorElement);
    };

    const fallbackFileName = fileNameOverride || deriveFileName(url);

    try {
        const response = await fetch(url, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);
        const fileBlob = await response.blob();
        const objectUrl = window.URL.createObjectURL(fileBlob);
        triggerBrowserDownload(objectUrl, fallbackFileName);
        // Give the browser a moment to start the download before revoking
        setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
    } catch (_) {
        // Graceful fallback for cross-origin (e.g., MinIO/S3): request with response header override
        try {
            const parsed = new URL(url, window.location.href);
            const dispositionValue = `attachment; filename="${fallbackFileName}"`;
            parsed.searchParams.set('response-content-disposition', dispositionValue);
            // Some providers also honor response-content-type
            parsed.searchParams.set('response-content-type', 'application/octet-stream');

            // Navigate without using the download attribute (ignored cross-origin)
            triggerBrowserDownload(parsed.toString());
        } catch (_) {
            // As a last resort, just navigate to the URL
            triggerBrowserDownload(url);
        }
    }
};

export const permanentRedirect = (url) => window.location.href = url;